import Icon from '@/components/ui/AppIcon';

interface ProximityCardProps {
  icon: string;
  title: string;
  distance: string;
  travelTime: string;
  description: string;
  highlights: string[];
  color: string;
}

const ProximityCard = ({
  icon,
  title,
  distance,
  travelTime,
  description,
  highlights,
  color,
}: ProximityCardProps) => {
  return (
    <div className="bg-card rounded-xl shadow-subtle hover:shadow-elevated transition-all duration-300 overflow-hidden border border-border group">
      <div className={`${color} p-6`}>
        <div className="flex items-center justify-between mb-4">
          <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center">
            <Icon name={icon as any} size={28} className="text-white" />
          </div>
          <div className="text-right">
            <p className="text-2xl font-bold text-white">{distance}</p>
            <p className="text-sm text-white/80">{travelTime}</p>
          </div>
        </div>
        <h3 className="font-display text-2xl font-semibold text-white">{title}</h3>
      </div>
      
      <div className="p-6">
        <p className="text-text-secondary mb-4">{description}</p>
        
        <div className="space-y-2">
          {highlights.map((highlight, index) => (
            <div key={index} className="flex items-start space-x-2">
              <Icon name="CheckCircleIcon" size={20} className="text-success flex-shrink-0 mt-0.5" />
              <span className="text-sm text-text-secondary">{highlight}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProximityCard;